import { formfileHandle, decodeComponentUrl } from '@/utils/utils';
import { mapGetters, mapMutations } from 'vuex';
let _ = require('lodash');
import domstyle from '@/view/map/hdmconfigv2/domstyle';
import uploadfile from '@/components/mapv2/uploadfile';
export default {
  name: 'dragcontentv2',
  components: {
    domstyle,
    uploadfile
  },
  meta: {
    title: ''
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      rightShow: false,
      defaultpicImg: require('@/assets/mapv2/defaultImage.jpg'),
      link: {
        url: '',
        way: true
      },
      dragNode: {}
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) this.formatValue(val);
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  mounted() {},
  methods: {
    ...mapMutations(['SET_MAPDOMSTYLE']),
    formatValue(val) {
      console.log(`------ dom编辑器内容管理数据 -------`);
      this.dragNode = _.cloneDeep(val);
      console.log(`this.dragNode`, this.dragNode);
      let style = this.dragNode.style;
      this.dragNode.style.width = Math.round(style.width * (style.scaleX ? style.scaleX : 1));
      this.dragNode.style.height = Math.round(style.height * (style.scaleY ? style.scaleY : 1));
      this.dragNode.style.x = Math.round(style.x);
      this.dragNode.style.y = Math.round(style.y);
      let data = this.dragNode.data;
      this.link.url = data.url !== undefined ? decodeComponentUrl(data.url) : '';
      this.link.way = data.way !== undefined ? data.way : true;
    },
    open() {
      this.rightShow = true;
    },
    close() {
      this.rightShow = false;
    },
    inputChange(val) {
      this.SET_MAPDOMSTYLE(val);
    },
    fileListHandle(val) {
      let that = this;
      this.SET_MAPDOMSTYLE({
        image: formfileHandle(val, 'imagebox', this.$route.query.uid)
      });
    },
    linkInputChange(val) {
      this.SET_MAPDOMSTYLE(this.link);
    }
  }
};